import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from '../home/home.component';
import { HomeRoutingModule } from './home-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CountUpModule } from 'ngx-countup';
import { ChartBarVerticalComponent } from './components/chart-bar-vertical/chart-bar-vertical.component';
import { LandingComponent } from './components/landing/landing.component';
import { CountUpComponent } from './components/count-up/count-up.component';

@NgModule({
  declarations: [HomeComponent, ChartBarVerticalComponent, LandingComponent, CountUpComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    NgxChartsModule,
    CountUpModule,
  ],
})
export class HomeModule {}
